module.exports = __webpack_public_path__ + "static/media/icon_beach_volleyball.cd38bd3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_beach_volleyball.png
// module id = 150
// module chunks = 0